'use client';

import { useEffect } from 'react';

import { getUtag } from '../tracking';

import { useIsTrackerReady } from './use-is-tracker-ready';

import type { Utag } from '../tracking';

type UseUtagHook = (closure: (utag: Utag) => void, deps?: any[]) => void;

/**
 * Use utag when it's ready.
 *
 * ```tsx
 * useUtag(utag => {
 *   utag.link(...);
 * }, []);
 * ```
 */
export const useUtag: UseUtagHook = (closure, deps) => {
  const trackerReady = useIsTrackerReady();

  useEffect(
    () => {
      if (!trackerReady) {
        return;
      }

      const utag = getUtag(window);

      if (typeof utag === 'undefined') {
        return;
      }

      closure(utag);
    },
    deps ? [trackerReady, ...deps] : undefined,
  );

  return;
};
